export function genAvatar(username) {
  const names = username.split(' ');

  return names
    .filter((name, index) => index === 0 || index === names.length - 1)
    .map((name) => name[0])
    .join('')
    .toUpperCase();
}
